module.exports = __webpack_public_path__ + "stockLibrary/service_4-44a2dad1c1f618737208f01e66b7dfd7.png";